import styled from '@emotion/styled';

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 64px;
  flex-shrink: 0;
`;

export const Logo = styled.h1`
  position: fixed;
  top: 24px;
  left: 24px;
  width: 116px;
  height: 18px;
  background-image: url('/img/logo.png');
  background-size: 117px, 18px;
  background-repeat: no-repeat;
`;

export const Help = styled.a`
  position: fixed;
  top: 24px;
  right: 24px;
  width: 54px;
  height: 54px;
  background: #000000;
  border-radius: 2px;
  opacity: 0.5;
  z-index: 10;
  cursor: pointer;
`;

export const Icon = styled.div`
  position: absolute;
  top: 11px;
  left: 11px;
  width: 32px;
  height: 32px;
  background-image: url('/img/icon_setting.png');
  background-repeat: no-repeat;
`;
